var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketRoundRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.66 435.406C47.754 432.937 144.001 373.499 144.001 255.998C144.001 138.873 48.347 79.435 43.722 76.622C32.348 69.81 28.598 55.091 35.379 43.716C42.16 32.372 56.847 28.591 68.284 35.372C73.315 38.372 192 110.685 192 255.998S73.315 473.625 68.284 476.625C64.441 478.906 60.222 480 56.066 480C47.91 480 39.941 475.813 35.441 468.312C28.66 456.969 32.348 442.25 43.66 435.406Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketRoundRight);
export default __webpack_public_path__ + "static/media/bracket-round-right.3d52e230114b97dfa131eaa3a077ec43.svg";
export { ForwardRef as ReactComponent };